import React from "react";
import classes from './Student.module.css'
import Score from './Score'
import useScoreLevelColor from '../../../../../../../hooks/useScoreLevelColor'
import StudentScoreClasses from "./StudentScore.module.css"
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import * as PathRouter from '../../../../../../../models/PathRoute'
import { onKeyDown } from "../../../../../../../service";


const Student = ({ firstName, lastName, studentScoreAverage, assessments, assessmentsList, id }) => {
    const levelColor = useScoreLevelColor();
    const direction = useSelector(state => state.translate.direction);
    const { homeUrl } = useSelector(state => state.application);
    const navigate = useNavigate();
    const _id = useParams().id;

    const clickStudentName = () => {
        navigate(`${homeUrl}/${PathRouter.LEARNING_TRACKING}/${_id}/${PathRouter.STUDENT_TRACKING}/${id}`)
    }

    return (
        <div className={`${classes.student}  ${StudentScoreClasses.studentWarrper} ${classes[direction]}`}>
            {studentScoreAverage && <div className={`${classes.StudentColor}`} style={{ background: `${Math.round(studentScoreAverage * 100) != '' ? levelColor(studentScoreAverage ? Math.round(studentScoreAverage * 100) : null).color : 'none    '}` }}></div>}
            <div className={`${classes.studentName}`} onClick={clickStudentName} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, clickStudentName)}>{firstName} {lastName}</div>
            <div className={classes.AvergeScore}>{studentScoreAverage ? Math.round(studentScoreAverage * 100) : null}</div>
            {assessmentsList.length ? assessmentsList?.length && assessmentsList.map((s, index) =>
                <Score key={index}
                    submission={assessments[s.id]}
                ></Score>) : null}
        </div >
    )
}

export default Student;